import {z}from'zod';const m=z.object({page:z.number().min(1).optional(),limit:z.number().max(100).min(1).optional()});export{m as CrudPaginationRequestSchema};